var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.buttonClass,attrs:{"href":_vm.href,"target":_vm.target,"variant":_vm.variant,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("icon-before"),_vm._v(" "+_vm._s(_vm.btnText)+" "),_vm._t("icon-after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }